// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5e-1";
export var standaloneTable = "_5e-0";